<template>
  <div id="">
    <el-form :model="addFormData" :rules="rules2" ref="addFormData" label-width="150px" class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
          <el-form-item prop="oldPwd" label="旧密码">
            <el-input type="text" v-model.trim="addFormData.password" placeholder="新密码"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item prop="newPwd" label="新密码">
            <el-input type="text" v-model.trim="addFormData.newPassword" placeholder="新密码"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="confirmPwd" label="确认新密码">
            <el-input type="text" v-model.trim="addFormData.confirmPassword" placeholder="确认新密码"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="">
          <el-button @click.native="exit">取 消</el-button>
          <el-button type="primary" @click.native="addSubmit">确 定</el-button>
      </span>
  </div>
</template>

<script>
import axios from 'axios';
import {HttpResp} from '../constant/index';
import {loginApi} from '../api/index';

export default {
    name: 'EditPwd',
    data() {
        return {
            addFormData: {
              password: '',
              newPassword: '',
              confirmPassword: '',
            },
            rules2: {
              password: [{required: true,message: '参数不能为空',trigger: 'blur'}],
              newPassword: [{required: true,message: '参数不能为空',trigger: 'blur'}],
              confirmPassword: [{required: true,message: '参数不能为空',trigger: 'blur'}]
            }
        }
    },
    methods: {
      exit(){
        this.$router.go(-1);
      },
      //增加一条记录
      addSubmit() {
          //先判断表单是否通过了判断
          this.$refs.addFormData.validate((valid) => {
              //代表通过验证 ,将参数传回后台
              if (valid) {
                  let param = Object.assign({}, this.addFormData);
                  axios.post("/system/admin/updatePassword", param).then((result) => {
                      //alert(result);
                      if (result.data.code == HttpResp.SUCCUSS) {
                          this.$message({
                              type: 'success',
                              message: '密码修改成功！',
                          });
                          this.logout();
                      } else {
                          this.$message({
                              type: 'error',
                              message: result.data.message,
                          });
                      }
                      this.dialogVisible = false;
                  });
              }
          });
      },
      logout() {
        //调用函数  传递参数 获取结果
        loginApi.logout().then(data => {
          if (data.code == HttpResp.SUCCUSS) {
            //退出
            //用vue路由跳转登入页面
            this.$router.push("/login");
          } else {
            this.$message({
              message: data.message,
              type: 'error'
            });
          }
        });
      }

    }

}
</script>



// WEBPACK FOOTER //
// src/components/EditPwd.vue